import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { rpmSummaryData } from '../mockData/rpm-summary-data';

const RpmSummaryApi = [rest.get(`${API_ROOT}rpm-summary`, (req, res, ctx) => res(ctx.json(rpmSummaryData)))];
export default RpmSummaryApi;
